import ActivityEditPageHeader from './ActivityEditPageHeader';

export default ActivityEditPageHeader;
